import React from 'react';

import { Box } from '@hz-design-system/web-ui';
import { ListingLocationDetails, SellerExternalWebsite } from '@/client/components/ListingsNew/components';

import Classes from './ListingLocationSellerWebsite.module.scss';

interface ListingLocationSellerWebsiteProps {
  location: { label: string; distance?: string };
  sellerInformation?: TSellerInformation;
}

const ListingLocationSellerWebsite: React.FC<ListingLocationSellerWebsiteProps> = ({ location, sellerInformation }) => {
  return (
    <Box
      as="div"
      name="Listing-group-bottom-row-location-and-website"
      suppressHydrationWarning
      className={Classes['hz-Listing-group-bottom-row-location-and-website']}
    >
      {!sellerInformation?.showWebsiteUrl && (!!location.label || !!location.distance) && (
        <ListingLocationDetails.Small location={location} />
      )}
      {sellerInformation?.showWebsiteUrl && sellerInformation?.sellerWebsiteUrl && (
        <SellerExternalWebsite sellerWebsiteUrl={sellerInformation.sellerWebsiteUrl} />
      )}
    </Box>
  );
};

export default ListingLocationSellerWebsite;
